module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading\n"
    }],
    staticClass: "choose-coupon sl-coupon"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                < " + _vm._s(_vm.$t('Functional.back')) + "\n              ")]), _vm._v("\n              " + _vm._s(_vm.$t('Views.ChooseCoupon.title')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "type-list"
  }, _vm._l((_vm.types), function(item) {
    return _c('router-link', {
      staticClass: "type",
      attrs: {
        "to": {
          name: 'Add-Coupon',
          query: {
            id: item.id,
            name: item.title
          }
        },
        "tag": "div"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$ga.event('Link', item.title, 'Choose coupon')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_c('div', {
    staticClass: "des-title"
  }, [_vm._v(_vm._s(_vm.$t('Functional.help')))]), _vm._v(" "), _vm._l((_vm.types), function(item, index) {
    return _c('div', {
      staticClass: "des-item"
    }, [_c('p', [_vm._v(_vm._s(item.id) + "、" + _vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {}, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.ChooseCoupon.example')) + ":")]), _vm._v(" "), _c('ul', _vm._l((item.example), function(it) {
      return _c('li', [_vm._v(_vm._s(it))])
    }))])])
  })], 2)])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30a83aac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coupons/choose-coupon.vue
// module id = 1093
// module chunks = 1